<template>
  <div class="order-empty">
   <img src="../assets/no_order.jpg"><span>{{title}}</span>
  </div>
</template>
<script>
export default {
  name: "NoList",
  props: {
    title: String
  }
};
</script>
<style scoped>
.order-empty {
  padding: 100px 0;
  font-size: 14px;
  text-align: center;
}
.order-empty img {
  display: block;
  margin: 12px auto;
}
.order-empty span {
  color: #999;
}
</style>
